import { render, staticRenderFns } from "./myPurchasesMobile.vue?vue&type=template&id=9d5bf04c&scoped=true&lang=html&"
import script from "./myPurchasesMobile.vue?vue&type=script&lang=js&"
export * from "./myPurchasesMobile.vue?vue&type=script&lang=js&"
import style0 from "./myPurchasesMobile.vue?vue&type=style&index=0&id=9d5bf04c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d5bf04c",
  null
  
)

export default component.exports